// extracted by mini-css-extract-plugin
export var boldCellText = "cc81a8eb5eb4db54605e613f61296988-css";